<template>
    <div class="container">
        <b-modal 
            :model-value="modalCreaCuenta" 
            :no-close-on-backdrop="true" 
            hide-footer 
                        centered 
            size="lg"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            :title="labels.title"
         @hide="clicked">
            <div class="uniform-modal-body">
                <!-- Contable -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.contable }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <b-form-select v-model="contable" class="form-input" @change="f_cambia_contable">
                            <option value="">{{ labels.select }}</option>
                            <option value="1">{{ labels.yes }}</option>
                            <option value="0">{{ labels.no }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Actual -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.actual }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <b-form-select v-model="actual" class="form-input">
                            <option value="">{{ labels.select }}</option>
                            <option value="1">{{ labels.yes }}</option>
                            <option value="0">{{ labels.no }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Operación -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.operacion }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <b-form-select v-model="operacion" class="form-input">
                            <option value="">{{ labels.select }}</option>
                            <option value="+">{{ labels.sumar }}</option>
                            <option value="-">{{ labels.restar }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Sección de Cuentas (Contable = SI) -->
                <template v-if="showCuenta">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="3" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.criterio }}</label>
                        </b-col>
                        <b-col cols="12" md="9" class="text-left">
                            <div class="criterio-inputs-wrapper">
                                <b-form-input 
                                    v-model="critCuenta" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                    autocomplete="off"
                                    :placeholder="labels.criterioCuentaPlaceholder"
                                    @input="f_criterio_cuenta"
                                />
                                <b-form-input 
                                    v-model="critDescripcion" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px;"
                                    autocomplete="off"
                                    :placeholder="labels.criterioDescripcionPlaceholder"
                                    @input="f_criterio_descripcion"
                                />
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Tabla de Cuentas -->
                    <div class="accounts-section mt-2">
                        <div v-if="listCuentasSelMul.length > 0" class="accounts-list mt-1">
                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                <b-button 
                                    size="sm"
                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                    @click="toggleSelectAllCuentas"
                                >
                                    {{ selectAllCuentas ? labels.deselectAll : labels.selectAll }}
                                </b-button>
                                <span style="font-size: 13px; color: #6c757d;">
                                    {{ labels.selected }}: <strong>{{ listadoCuentas.length }}</strong> / {{ listCuentasSelMul.length }}
                                </span>
                            </div>

                            <div class="custom-scroll-table">
                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                        <tr>
                                            <th style="width: 120px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.account }}
                                            </th>
                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.description }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr 
                                            v-for="cuenta in listCuentasSelMul" 
                                            :key="cuenta.id"
                                            @click="toggleCuentaSelection(cuenta)"
                                            :class="{'table-active-blue': isCuentaSelected(cuenta)}"
                                            style="cursor: pointer;"
                                        >
                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                <strong>{{ cuenta?.cuenta || '' }}</strong>
                                            </td>
                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="cuenta.descripcion">
                                                {{ cuenta?.descripcion || '' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-else-if="!loadingCuentas" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <span class="text-muted" style="font-size: 13px;">{{ labels.noAccountsFound }}</span>
                        </div>

                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <b-spinner small class="mr-1"></b-spinner>
                            <span style="font-size: 13px;">{{ labels.loadingAccounts }}</span>
                        </div>
                    </div>
                </template>

                <!-- Formulación (Contable = NO) -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="showFormulacion">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.formulacion }}</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <div class="d-flex flex-wrap align-items-center gap-3">
                            <div class="custom-checkbox-wrapper">
                                <input 
                                    type="radio"
                                    id="chk_sf"
                                    value="s"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_sf">Suma</label>
                            </div>
                            <div class="custom-checkbox-wrapper">
                                <input 
                                    type="radio"
                                    id="chk_n"
                                    value="n"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_n">Niif</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_m"
                                    value="m"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_m">Valor Manual</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_a"
                                    value="a"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_a">Ajuste Consolidacion</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_ac"
                                    value="ac"
                                    v-model="chk"
                                    @change="actualizarVistaFormulacion"
                                />
                                <label for="chk_ac">Ajuste Combinacion</label>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!-- Suma -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="showSuma">
                    <b-col cols="12" md="3" class="text-left uniform-label-col">
                        <label class="form-label">Suma:</label>
                    </b-col>
                    <b-col cols="12" md="9" class="text-left">
                        <b-form-input v-model="sumNiv" type="text" class="form-input" />
                    </b-col>
                </b-row>

                <!-- NIIF -->
                <template v-if="showNiif">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="3" class="text-left uniform-label-col">
                            <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">
                                {{ labels.niifFilter }}
                            </label>
                        </b-col>
                        <b-col cols="12" md="9" class="text-left">
                            <div class="criterio-inputs-wrapper">
                                <b-form-input 
                                    v-model="critNiifCode" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                    autocomplete="off"
                                    :placeholder="labels.niifCodePlaceholder"
                                    @input="filtraNiifs"
                                />
                                <b-form-input 
                                    v-model="critNiifName" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px;"
                                    autocomplete="off"
                                    :placeholder="labels.niifNamePlaceholder"
                                    @input="filtraNiifs"
                                />
                            </div>
                        </b-col>
                    </b-row>

                    <div class="accounts-section mt-2">
                        <div v-if="listNiifFiltered.length > 0" class="accounts-list mt-1">
                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                <b-button 
                                    size="sm"
                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                    @click="toggleSelectAllNiifs"
                                >
                                    {{ selectAllNiifs ? labels.deselectAll : labels.selectAll }}
                                </b-button>
                                <span style="font-size: 13px; color: #6c757d;">
                                    {{ labels.selected }}: <strong>{{ selectedNiifs.length }}</strong> / {{ listNiifFiltered.length }}
                                </span>
                            </div>

                            <div class="custom-scroll-table">
                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                        <tr>
                                            <th style="width: 120px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.code }}
                                            </th>
                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.niifName }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr 
                                            v-for="niif in listNiifFiltered" 
                                            :key="niif.id"
                                            @click="toggleNiifSelection(niif)"
                                            :class="{'table-active-blue': isNiifSelected(niif)}"
                                            style="cursor: pointer;"
                                        >
                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                <strong>{{ niif?.niif || '' }}</strong>
                                            </td>
                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="niif.nameNiif">
                                                {{ niif?.nameNiif || '' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-else-if="listNiif.length > 0 && !loadingNiifs" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <span class="text-muted" style="font-size: 13px;">{{ labels.noNiifsMatch }}</span>
                        </div>

                        <div v-else-if="loadingNiifs" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <b-spinner small class="mr-1"></b-spinner>
                            <span style="font-size: 13px;">{{ labels.loadingNiifs }}</span>
                        </div>

                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <span class="text-muted" style="font-size: 13px;">{{ labels.noNiifsAvailable }}</span>
                        </div>
                    </div>
                </template>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4">
                    <b-button class="reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary ml-2" @click="guardaCuenta">{{ labels.save }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PlanCuentas from "../../services/PlanCuentas"
import Company from "../../services/Company"
import PlanConsolidacion from '../../services/PlanConsolidacion'
import Nivel from '../../services/Nivel'

export default {
    name: "CreaCuenta",
    props: ["modalCreaCuenta", "nivelSelected", "vigComSelected", "cuentasCreadas"],
    data: () => ({
        administrador: false,
        contable: null,
        cuenta: "",
        actual: null,
        operacion: "",
        showCuenta: false,
        showFormulacion: false,
        chk: "",
        showSuma: false,
        showNiif: false,
        showConsolidado: false,
        listNiif: [],
        searchCuenta: "",
        searchNiif: "",
        searchNivel: "",
        selectedNiifs: [],
        listLevel: [],
        selVigencia: "",
        listVigencia: [],
        listCompany: [],
        arrNiif: [],
        sumNiv: "",
        criterioC: "",
        criterioD: "",
        listadoCuentas: [],
        listCuentas: [],
        showCuentas: [],
        listCuentasNew: [],
        selectAll: false,
        listFirstLevel: [],
        listSecondLevel: [],
        filteredNiif: [],
        filteredCuenta: [],
        // Nuevas variables para el diseño mejorado
        listCuentasSelMul: [],
        selectAllCuentas: false,
        loadingCuentas: false,
        critCuenta: '',
        critDescripcion: '',
        listNiifFiltered: [],
        selectAllNiifs: false,
        loadingNiifs: false,
        critNiifCode: '',
        critNiifName: '',
        selectedCuentas: []
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear Detalle",
                    select: "Seleccione...",
                    save: "Guardar",
                    close: "Cerrar",
                    contable: "Contable:",
                    criterio: "Criterio:",
                    yes: "SI",
                    no: "NO",
                    account: "Cuenta:",
                    actual: "Actual:",
                    operacion: "Operación:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formula:",
                    vigencia: "Vigencia:",
                    company: "Compañía:",
                    searchPlaceholderCuenta: "Buscar CUENTA...",
                    searchPlaceholder: "Buscar NIIF...",
                    searchPlaceholderNivel: "Buscar Nivel...",
                    selected: "Seleccionados",
                    noResults: "No se encontraron resultados",
                    tabNiif: "NIIFs",
                    consolidado: "Consolidado",
                    description: "Descripción",
                    criterioCuentaPlaceholder: "Buscar por cuenta...",
                    criterioDescripcionPlaceholder: "Buscar por descripción...",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    noAccountsFound: "No se encontraron cuentas",
                    loadingAccounts: "Cargando cuentas...",
                    niifFilter: "Filtro NIIF",
                    niifCodePlaceholder: "Buscar por código...",
                    niifNamePlaceholder: "Buscar por nombre...",
                    code: "Código",
                    niifName: "Nombre NIIF",
                    noNiifsAvailable: "No hay NIIF disponibles",
                    noNiifsMatch: "No hay NIIF que coincidan con el filtro",
                    loadingNiifs: "Cargando NIIF..."
                }
            } else {
                return {
                    title: "Create Detail",
                    select: "Select...",
                    save: "Save",
                    close: "Close",
                    contable: "Accountant:",
                    criterio: "Search:",
                    yes: "YES",
                    no: "NO",
                    account: "Account:",
                    actual: "Actual:",
                    operacion: "Operation:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formula:",
                    vigencia: "Validity:",
                    company: "Company:",
                    searchPlaceholderCuenta: "Search ACCOUNT...",
                    searchPlaceholder: "Search NIIF...",
                    searchPlaceholderNivel: "Search Level...",
                    selected: "Selected",
                    noResults: "No result found",
                    tabNiif: "NIIFs",
                    consolidado: "Consolidated",
                    description: "Description",
                    criterioCuentaPlaceholder: "Search by account...",
                    criterioDescripcionPlaceholder: "Search by description...",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    noAccountsFound: "No accounts found",
                    loadingAccounts: "Loading accounts...",
                    niifFilter: "NIIF Filter",
                    niifCodePlaceholder: "Search by code...",
                    niifNamePlaceholder: "Search by name...",
                    code: "Code",
                    niifName: "NIIF Name",
                    noNiifsAvailable: "No NIIF available",
                    noNiifsMatch: "No NIIF match the filter",
                    loadingNiifs: "Loading NIIF..."
                }
            }
        }
    },
    methods: {
        // ===== MÉTODOS PARA CUENTAS =====
        isCuentaSelected(cuenta) {
            if (!cuenta || !cuenta.cuenta) return false
            return this.listadoCuentas.includes(cuenta.cuenta)
        },

        toggleCuentaSelection(cuenta) {
            if (!cuenta || !cuenta.cuenta) return
            const cuentaStr = String(cuenta.cuenta)
            const index = this.listadoCuentas.findIndex(item => String(item) === cuentaStr)
            if (index > -1) {
                this.listadoCuentas.splice(index, 1)
            } else {
                this.listadoCuentas.push(cuenta.cuenta)
            }
            this.updateSelectAllCuentas()
        },

        toggleSelectAllCuentas() {
            this.selectAllCuentas = !this.selectAllCuentas
            const listadoCuentasStr = this.listadoCuentas.map(item => String(item))
            
            if (this.selectAllCuentas) {
                const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null)
                allCodes.forEach(code => {
                    const codeStr = String(code)
                    if (!listadoCuentasStr.includes(codeStr)) {
                        this.listadoCuentas.push(code)
                    }
                })
            } else {
                const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null)
                const codesStr = allCodes.map(c => String(c))
                this.listadoCuentas = this.listadoCuentas.filter(code => !codesStr.includes(String(code)))
            }
        },

        updateSelectAllCuentas() {
            if (this.listCuentasSelMul.length === 0) {
                this.selectAllCuentas = false
                return
            }
            const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null)
            const listadoCuentasStr = this.listadoCuentas.map(item => String(item))
            this.selectAllCuentas = allCodes.every(code => listadoCuentasStr.includes(String(code)))
        },

        f_criterio_cuenta() {
            if (this.critCuenta.length == 0) {
                this.listCuentasSelMul = [...this.listCuentas]
            } else {
                const criterio = "^" + this.critCuenta
                this.listCuentasSelMul = this.listCuentas.filter(
                    (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
                )
            }
            this.updateSelectAllCuentas()
        },

        f_criterio_descripcion() {
            if (this.critDescripcion.length == 0) {
                this.listCuentasSelMul = [...this.listCuentas]
            } else {
                const searchTerm = this.critDescripcion.toUpperCase()
                this.listCuentasSelMul = this.listCuentas.filter(
                    (cuenta) => cuenta.descripcion && 
                        cuenta.descripcion.toUpperCase().includes(searchTerm)
                )
            }
            this.updateSelectAllCuentas()
        },

        consCuentas() {
            this.loadingCuentas = true
            let form = {
                'compania': this.vigComSelected.compania,
                'vigencia': this.vigComSelected.vigencia,
                'cuentasList': this.cuentasCreadas || []
            }
            
            const service = this.$route.params.tipo == 'directo' 
                ? Nivel.cuentasNoCreadas 
                : Nivel.cuentasNoCreadasInd
            
            service(form)
                .then((res) => {
                    this.listCuentas = res.data.cuentas || []
                    this.listCuentasSelMul = res.data.cuentas || []
                    this.loadingCuentas = false
                    this.updateSelectAllCuentas()
                })
                .catch((err) => {
                    console.log(err)
                    this.listCuentas = []
                    this.listCuentasSelMul = []
                    this.loadingCuentas = false
                })
        },

        // ===== MÉTODOS PARA NIIF =====
        isNiifSelected(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return false
            return this.selectedNiifs.some(item => String(item) === String(niif.niif))
        },

        toggleNiifSelection(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return
            const niifStr = String(niif.niif)
            const index = this.selectedNiifs.findIndex(item => String(item) === niifStr)
            if (index > -1) {
                this.selectedNiifs.splice(index, 1)
            } else {
                this.selectedNiifs.push(niif.niif)
            }
            this.updateSelectAllNiifs()
        },

        toggleSelectAllNiifs() {
            this.selectAllNiifs = !this.selectAllNiifs
            const selectedNiifsStr = this.selectedNiifs.map(item => String(item))
            
            if (this.selectAllNiifs) {
                const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null)
                allCodes.forEach(code => {
                    const codeStr = String(code)
                    if (!selectedNiifsStr.includes(codeStr)) {
                        this.selectedNiifs.push(code)
                    }
                })
            } else {
                const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null)
                const codesStr = allCodes.map(c => String(c))
                this.selectedNiifs = this.selectedNiifs.filter(code => !codesStr.includes(String(code)))
            }
        },

        updateSelectAllNiifs() {
            if (this.listNiifFiltered.length === 0) {
                this.selectAllNiifs = false
                return
            }
            const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null)
            const selectedNiifsStr = this.selectedNiifs.map(item => String(item))
            this.selectAllNiifs = allCodes.every(code => selectedNiifsStr.includes(String(code)))
        },

        filtraNiifs() {
            let filtered = [...this.listNiif]
            
            if (this.critNiifCode) {
                const codeFilter = this.critNiifCode.toUpperCase()
                filtered = filtered.filter(n => {
                    const code = n?.niif
                    if (code === undefined || code === null) return false
                    return String(code).toUpperCase().includes(codeFilter)
                })
            }
            
            if (this.critNiifName) {
                const nameFilter = this.critNiifName.toUpperCase()
                filtered = filtered.filter(n => {
                    const name = n?.nameNiif
                    if (name === undefined || name === null) return false
                    return String(name).toUpperCase().includes(nameFilter)
                })
            }
            
            this.listNiifFiltered = filtered
            this.updateSelectAllNiifs()
        },

        cargarNiif() {
            if (this.vigComSelected.vigencia == "") {
                this.$toast.error("El campo vigencia debe estar diligenciado")
                return
            }
            
            this.loadingNiifs = true
            
            PlanConsolidacion.getPlanConsPorCompVige(
                this.vigComSelected.vigencia,
                this.vigComSelected.codReporte
            )
            .then((res) => {
                const niifData = res.data.planConsNiif || []
                this.listNiif = niifData
                this.listNiifFiltered = [...niifData]
                this.updateSelectAllNiifs()
                this.loadingNiifs = false
            })
            .catch((err) => {
                console.log(err)
                this.listNiif = []
                this.listNiifFiltered = []
                this.loadingNiifs = false
            })
        },

        actualizarVistaFormulacion() {
            if (this.chk == 'n') {
                this.cargarNiif()
                this.showNiif = true
                this.showSuma = false
            } else if (this.chk == 's') {
                this.showSuma = true
                this.showNiif = false
                this.selectedNiifs = []
            } else {
                this.showSuma = false
                this.showNiif = false
                this.selectedNiifs = []
            }
        },

        // ===== OTROS MÉTODOS =====
        f_nuevo_criterio_niif() {
            this.filteredNiif = this.f_filteredNiif()
        },

        f_filteredNiif() {
            const niif = this.searchNiif.toLowerCase() || ""
            const nivel = this.searchNivel.toLowerCase() || ""
            const listParcial = this.listNiif.filter(n =>
                n.niif.toString().includes(niif) || 
                (n.nameNiif && n.nameNiif.toLowerCase().includes(niif)) || 
                (n.descripcion && n.descripcion.toLowerCase().includes(niif))
            )
            return listParcial?.filter(n =>
                n.primer_nivel.toString().includes(nivel) || 
                n.segundo_nivel.toString().includes(nivel) || 
                (n.namePrimerNivel && n.namePrimerNivel.toLowerCase().includes(nivel)) || 
                (n.nameSegundoNivel && n.nameSegundoNivel.toLowerCase().includes(nivel))
            )
        },

        f_nuevo_criterio_cuenta() {
            this.filteredCuenta = this.f_filteredCuenta()
        },

        f_filteredCuenta() {
            const cuenta = "^" + (this.searchCuenta.toLowerCase() || "")
            return this.listCuentas.filter(n => n.cuenta.match(cuenta))
        },

        getFirstLevelDescription(levelDescripcion) {
            return levelDescripcion ? levelDescripcion.levelDescripcion : '-'
        },

        getSecondLevelDescription(levelDescripcion) {
            return levelDescripcion ? levelDescripcion.levelDescripcion : '-'
        },

        clearFields() {
            this.contable = null
            this.actual = null
            this.operacion = ""
            this.chk = ""
            this.sumNiv = ""
            this.selectedNiifs = []
            this.listadoCuentas = []
            this.listCuentas = []
            this.listCuentasSelMul = []
            this.listNiif = []
            this.listNiifFiltered = []
            this.selectAll = false
            this.selectAllCuentas = false
            this.selectAllNiifs = false
            this.showCuenta = false
            this.showFormulacion = false
            this.showSuma = false
            this.showNiif = false
            this.showConsolidado = false
            this.critCuenta = ''
            this.critDescripcion = ''
            this.critNiifCode = ''
            this.critNiifName = ''
            this.searchCuenta = ""
            this.searchNiif = ""
            this.searchNivel = ""
            this.filteredNiif = []
            this.filteredCuenta = []
        },

        f_cambia_contable() {
            if (this.contable == 0) {
                this.showCuenta = false
                this.showFormulacion = true
                this.listCuentas = []
                this.listCuentasSelMul = []
                this.listadoCuentas = []
            } else if (this.contable == 1) {
                this.showCuenta = true
                this.showFormulacion = false
                this.showSuma = false
                this.showNiif = false
                this.chk = ""
                this.selectedNiifs = []
                this.consCuentas()
            }
        },

        guardaCuenta() {
            if (this.chk == 'n' && this.selectedNiifs.length == 0) {
                this.$toast.error("Niif sin seleccionar")
                return
            }

            if (this.vigComSelected.vigencia == "") {
                this.$toast.error("El campo vigencia debe estar diligenciado")
                return
            } else if (this.vigComSelected.compania == "") {
                this.$toast.error("El campo compañía debe estar diligenciado")
                return
            } else if (this.contable == null || this.contable == "") {
                this.$toast.error("El campo contable debe estar diligenciado")
                return
            } else if (this.actual == null || this.actual == "") {
                this.$toast.error("El campo actual debe estar diligenciado")
                return
            } else if (this.operacion == "") {
                this.$toast.error("El campo operación debe estar diligenciado")
                return
            }

            if (this.contable == 1 && this.listadoCuentas.length == 0) {
                this.$toast.error("Debe seleccionar al menos una cuenta")
                return
            }

            if (this.contable == 0 && !this.chk) {
                this.$toast.error("Debe seleccionar un tipo de formulación")
                return
            }

            let dataInfo = {
                "vigencia": this.vigComSelected.vigencia,
                "compania": this.vigComSelected.compania,
                "codReporte": this.vigComSelected.codReporte,
                "contable": this.contable,
                "cuenta": this.contable == 1 ? this.listadoCuentas : "",
                "actual": this.actual,
                "operacion": this.operacion,
                "nivel": this.nivelSelected,
                "formulacion": this.contable == 0 ? this.chk : "",
                "formSumaNiv": this.chk == "s" ? this.sumNiv : "",
                "formNiif": this.chk == "n" ? this.selectedNiifs : "",
                'idUser': this.$store.state.userId
            }

            const service = this.$route.params.tipo == 'directo' 
                ? Nivel.createNewCuentaNivelEfe 
                : Nivel.createNewCuentaNivelEfeInd

            service(dataInfo)
                .then((res) => {
                    this.$toast.success(res.data.message)
                })
                .catch((err) => {
                    console.log(err)
                    if (err.response && err.response.status == 412) {
                        this.$toast.error(err.response.data.message)
                    }
                })
                .finally(() => {
                    setTimeout(() => {
                        this.reloadTable()
                    }, 2500)
                })
        },

        clicked() {
            this.clearFields()
            this.$emit('clicked', false)
        },

        reloadTable() {
            this.$emit('reloadTable', this.nivelSelected, this.vigComSelected.vigencia, this.vigComSelected.compania, this.vigComSelected.codReporte)
        }
    },

    mounted() {
        this.clearFields()
        
        if (this.$route.name == "nivelesADM") {
            this.administrador = true
        }

        PlanCuentas.getVigenciaPlancuentas()
            .then((result) => {
                this.listVigencia = result.data.getVigencia
            })
            .catch((err) => {
                console.log(err)
            })

        Company.getAllCompanies()
            .then((result) => {
                this.listCompany = result.data.companies
            })
            .catch((err) => {
                console.log(err)
            })

        if (this.vigComSelected && this.vigComSelected.vigencia) {
            PlanConsolidacion.getPlanConsPorCompVige(
                this.vigComSelected.vigencia,
                this.vigComSelected.codReporte
            )
            .then((res) => {
                this.listNiif = res.data.planConsNiif || []
                this.listNiif.forEach(n => n._selected = false)
                this.selectedNiifs = []
                this.listNiifFiltered = [...this.listNiif]
            })
            .catch((err) => console.log(err))
        }
    },

    watch: {
        contable(valNew) {
            if (valNew == 0) {
                this.showCuenta = false
                this.showFormulacion = true
                this.listCuentas = []
                this.listCuentasSelMul = []
                this.listadoCuentas = []
            } else if (valNew == 1) {
                this.showCuenta = true
                this.showFormulacion = false
                this.showSuma = false
                this.showNiif = false
                this.chk = ""
                this.selectedNiifs = []
                this.consCuentas()
            }
        },

        chk() {
            this.actualizarVistaFormulacion()
        },

        modalCreaCuenta(valNew) {
            if (valNew) {
                this.clearFields()
                if (this.vigComSelected && this.vigComSelected.compania) {
                    this.consCuentas()
                }
            }
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ========== ESTILOS DEL MODAL ========== */
.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-form-row {
    margin-bottom: 12px;
}

.uniform-label-col label {
    margin-bottom: 0;
    font-weight: 500;
    font-size: 14px;
}

.form-input {
    width: 100%;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

/* ========== HEADER DEL MODAL ========== */
.reset-modal-header {
    background-color: #2e507a;
    color: white;
    padding: 16px 20px;
    border-radius: 8px 8px 0 0;
}

.reset-modal-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.reset-modal-body {
    padding: 24px 20px;
    background-color: #f8f9fa;
}

/* ========== CRITERIO DE BÚSQUEDA ========== */
.criterio-inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.accounts-section {
    margin-top: 8px;
}

.select-all-container {
    padding: 4px 0;
}

/* ========== TABLA SCROLLABLE ========== */
.custom-scroll-table {
    height: 200px !important;
    min-height: 200px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    position: relative !important;
}

.custom-scroll-table table {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin-bottom: 0 !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
}

.custom-scroll-table table thead {
    display: table-header-group !important;
    width: 100% !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}

.custom-scroll-table table thead tr {
    display: table-row !important;
    width: 100% !important;
}

.custom-scroll-table table thead th {
    background-color: #f8f9fa !important;
    border-bottom: 2px solid #dee2e6 !important;
    padding: 6px 8px !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    color: #495057 !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
}

.custom-scroll-table table thead th:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
}

.custom-scroll-table table thead th:last-child {
    width: auto !important;
}

.custom-scroll-table table tbody {
    display: table-row-group !important;
    width: 100% !important;
}

.custom-scroll-table table tbody tr {
    display: table-row !important;
    width: 100% !important;
    cursor: pointer !important;
    border-radius: 8px !important;
}

.custom-scroll-table table tbody td {
    padding: 5px 8px !important;
    border: none !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
}

.custom-scroll-table table tbody td:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
    border-radius: 8px 0 0 8px !important;
}

.custom-scroll-table table tbody td:last-child {
    width: auto !important;
    border-radius: 0 8px 8px 0 !important;
}

.custom-scroll-table table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px !important;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8 !important;
}

.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-active-blue td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.table-active-blue td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

/* ========== CHECKBOX NATIVOS ========== */
.custom-checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
}

.custom-checkbox-wrapper input[type="radio"] {
    width: 16px;
    height: 16px;
    accent-color: #2e507a;
    cursor: pointer;
    margin: 0;
    flex-shrink: 0;
}

.custom-checkbox-wrapper label {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #495057;
    cursor: pointer;
}

.gap-2 {
    gap: 8px;
}

.gap-3 {
    gap: 12px;
}

/* ========== BOTONES ========== */
.reset-dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 768px) {
    .custom-scroll-table {
        height: 160px !important;
        min-height: 160px !important;
        max-height: 160px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 80px !important;
        min-width: 80px !important;
        max-width: 80px !important;
        font-size: 11px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }
}

@media (max-width: 576px) {
    .uniform-label-col {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 4px;
        text-align: left !important;
    }
    
    .uniform-form-row .col-md-8,
    .uniform-form-row .col-md-9 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .custom-scroll-table {
        height: 140px !important;
        min-height: 140px !important;
        max-height: 140px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 60px !important;
        min-width: 60px !important;
        max-width: 60px !important;
        font-size: 10px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 11px !important;
        padding: 3px 4px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 10px !important;
        padding: 3px 4px !important;
    }

    .custom-checkbox-wrapper {
        gap: 4px;
    }

    .custom-checkbox-wrapper input[type="radio"] {
        width: 14px;
        height: 14px;
    }

    .custom-checkbox-wrapper label {
        font-size: 13px;
    }

    .gap-3 {
        gap: 8px;
    }

    .reset-btn-primary,
    .reset-btn-secondary {
        width: 100%;
        margin: 4px 0 !important;
    }

    .reset-dialog-actions {
        flex-direction: column;
    }

    .reset-dialog-actions .reset-btn-secondary,
    .reset-dialog-actions .reset-btn-primary {
        width: 100%;
        margin: 4px 0 !important;
    }
}
</style>